import React, { useEffect, useMemo, useState } from "react";
import { IoChevronBack, IoSearchOutline } from "react-icons/io5";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Profile from "../../../Assets/Images/Profile.png";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { fetchAttendanceDetail } from "../../attendance/api";

const ApproveAttendance = () => {
  const { summaryDate, setSummaryDate, openToast, baseUrl, setAttendance } = useGlobalContext();
  const location = useLocation();
  const initialAttendance = location.state?.attendance || [];
  const navigate = useNavigate();
  const [staffData, setStaffData] = useState(initialAttendance.filter((staff) => staff.punchRecord?.[0]?.status === "PRESENT" && staff.punchRecord?.[0]?.isApproved !== true));
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchStaff, setSearchStaff] = useState("");
  const [selectedStaff, setSelectedStaff] = useState([]);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await fetchAttendanceDetail(summaryDate);
      setStaffData(data.records.filter((staff) => staff.punchRecord?.[0]?.status === "PRESENT" && staff.punchRecord?.[0]?.isApproved !== true) || []);
      setAttendance(data.records);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [summaryDate]);

  const filteredStaffData = useMemo(() => {
    if (!searchStaff.trim()) return staffData;
    return staffData.filter((staff) =>
      staff?.staffDetails?.User?.name?.toLowerCase().includes(searchStaff.toLowerCase())
    );
  }, [searchStaff, staffData]);

  const calcTimeDiff = (item) => {
    const punchInTime = item?.punchRecord?.[0]?.punchIn?.punchInTime;
    const punchOutTime = item?.punchRecord?.[0]?.punchOut?.punchOutTime;

    if (punchInTime && punchOutTime) {
      const inTime = new Date(punchInTime);
      const outTime = new Date(punchOutTime);
      const diffInMs = outTime - inTime;
      const hours = Math.floor(diffInMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    }
    return "0:00";
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (staff) => {
    setSelectedStaff((prevSelected) => {
      if (prevSelected.includes(staff)) {
        return prevSelected.filter((item) => item !== staff);
      } else {
        return [...prevSelected, staff];
      }
    });
  };

  // Handle select all checkbox
  const handleSelectAll = () => {
    if (selectedStaff.length === filteredStaffData.length) {
      setSelectedStaff([]); // Deselect all
    } else {
      setSelectedStaff(filteredStaffData); // Select all
    }
  };

  const approveStaffPunchRecord = async () => {

    if (selectedStaff.length === 0) {
      openToast("Please select a staff member for approval", "warning");
      return;
    }

    setLoading(true);

    try {
      const result = await fetch(`${baseUrl}punch/records/approve`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem(
            "flowChangerAuthToken"
          )}`,
        },
        body: JSON.stringify({ staffIds: selectedStaff.map((staff) => staff.staffId) }),
      });

      const response = await result.json();

      if (result.ok) {
        setSelectedStaff([]);
        openToast("Selected Staff Attendance Approved Successfully", "success");
        onCloseModal();
        fetchData();
        navigate("/attendence_summary");
      } else {
        openToast(response.error || response.message || "Something went wrong", "error");
      }
    } catch (err) {
      openToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };
  console.log(selectedStaff);

  return (
    <div className="min-h-screen w-full bg-gray-50">
      <div className="h-full w-full p-6">
        {/* Back Button */}
        <Link to="/attendence_summary" className="flex items-center text-[#27004a] mb-4">
          <IoChevronBack className="w-5 h-5" />
          <span className="ml-1">Back</span>
        </Link>

        {/* Header */}
        <h1 className="text-xl font-medium text-gray-800 mb-6">
          Attendance Pending for Approval
        </h1>

        {/* Date Navigation */}
        <div className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm mb-4">
          <input
            type="date"
            value={summaryDate}
            onChange={(e) => setSummaryDate(e.target.value)}
            className="border-[#dbdbdb] cursor-pointer bg-white p-[6px] border rounded-[6px] font-medium text-[14px] focus:outline-none"
          />

          <button className="second-btn" onClick={onOpenModal}>
            Approve
          </button>
          <Modal open={open} onClose={onCloseModal} center>
            <h2 className="text-[20px] font-medium">Bulk Approve Attendance</h2>
            <p className="text-[#959595] text-[15px] mt-[10px]">{summaryDate}</p>
            <h3 className="mt-[22px] mb-[30px] font-medium">
              Are you sure you want to approve attendance of{" "}
              <span className="text-black font-medium">{selectedStaff.length} Staff?</span>
            </h3>
            <div className="flex items-center justify-end gap-[10px]">
              <button onClick={onCloseModal} className="first-btn">
                Cancel
              </button>
              <button className={"second-btn " + (loading && "opacity-50 cursor-not-allowed")} disabled={loading} onClick={approveStaffPunchRecord}>Approve</button>
            </div>
          </Modal>
        </div>

        {/* Search Bar */}
        <div className="relative mb-6">
          <IoSearchOutline className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            value={searchStaff}
            onChange={(e) => setSearchStaff(e.target.value)}
            type="text"
            placeholder="Search Staff"
            className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Staff List */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="grid grid-cols-12 px-4 py-3 bg-gray-50 text-sm text-gray-600">
            <div className="col-span-1">
              <input
                type="checkbox"
                className="rounded border-[#27004a] text-blue-600 accent-[#27004a]"
                onChange={handleSelectAll}
                checked={selectedStaff.length === filteredStaffData.length && selectedStaff.length > 0}
              />
            </div>
            <div className="col-span-3">Staff Name</div>
            <div className="col-span-4">Punch In</div>
            <div className="col-span-4">Punch Out</div>
          </div>

          <div className="divide-y divide-gray-100">
            {filteredStaffData.length === 0 && !loading && (
              <p className="text-center text-red-600 py-4">No staff found for this date for approval</p>
            )}
            {filteredStaffData.length === 0 && loading && (
              <div className="flex justify-center py-4 w-full">
                <ClipLoader color="#27004a" size={40} />
              </div>
            )}
            {filteredStaffData.map((staff, index) => (
              <div key={index} className="grid grid-cols-12 px-4 py-4 hover:bg-gray-50">
                <div className="col-span-1 flex items-center">
                  <input
                    type="checkbox"
                    className="rounded border-[#27004a] text-blue-600 accent-[#27004a]"
                    onChange={() => handleCheckboxChange(staff)}
                    checked={selectedStaff.includes(staff)}
                  />
                </div>
                <div className="col-span-3 flex items-center gap-2">
                  <img
                    src={Profile || "/placeholder.svg"}
                    alt="Staff"
                    className="w-8 h-8 rounded-full"
                  />
                  <div>
                    <div className="font-medium text-gray-800">{staff.staffDetails?.User?.name}</div>
                    <div className="text-sm text-gray-500">{calcTimeDiff(staff)}</div>
                  </div>
                </div>
                <div className="col-span-4 text-gray-800">
                  {staff?.punchRecord?.[0]?.punchIn?.punchInTime ? new Date(staff.punchRecord[0].punchIn.punchInTime).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  }) : "N/A"}
                </div>
                <div className="col-span-4 text-gray-800">
                  {staff?.punchRecord?.[0]?.punchOut?.punchOutTime ? new Date(staff.punchRecord[0].punchOut.punchOutTime).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  }) : "N/A"}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveAttendance;
